import React, { useState } from 'react';
import { MessageCircle, X, CheckCircle } from 'lucide-react';
import { companyInfo, whatsappMessage } from '../data/mock';

export const WhatsAppFloat = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const openWhatsApp = () => {
    const message = encodeURIComponent(whatsappMessage);
    window.open(`https://wa.me/${companyInfo.whatsapp}?text=${message}`, '_blank');
  };

  return (
    <>
      <style>{`
        @keyframes gentlePulse {
          0%, 100% { 
            transform: scale(1);
            opacity: 0.6;
          }
          50% { 
            transform: scale(1.05);
            opacity: 0.8;
          }
        }
        
        @keyframes subtleBounce {
          0%, 100% { 
            transform: translateY(0);
          }
          50% { 
            transform: translateY(-4px);
          }
        }

        .gentle-pulse {
          animation: gentlePulse 3s ease-in-out infinite;
        }

        .subtle-bounce {
          animation: subtleBounce 2s ease-in-out infinite;
        }
      `}</style>

      <div 
        className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3"
        onMouseEnter={() => setIsExpanded(true)}
        onMouseLeave={() => setIsExpanded(false)}
      >
        {/* Expanded Info Card - Aparece no hover */}
        {isExpanded && (
          <div 
            className="bg-white rounded-2xl shadow-2xl p-4 max-w-xs border border-gray-100"
            style={{
              animation: 'slideUp 0.3s ease-out'
            }}
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center">
                  <MessageCircle className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-sm">Desloca Locadora</h4>
                  <div className="flex items-center gap-1">
                    <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                    <span className="text-xs text-green-600 font-medium">Online agora</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-2 mb-3">
              <p className="text-sm text-gray-700">
                👋 Olá! Como podemos ajudar você hoje?
              </p>
              <div className="space-y-1.5">
                <div className="flex items-center gap-2 text-xs text-gray-600">
                  <CheckCircle className="w-3.5 h-3.5 text-green-500" />
                  <span>Atendimento humanizado</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-gray-600">
                  <CheckCircle className="w-3.5 h-3.5 text-green-500" />
                  <span>Resposta rápida</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-gray-600">
                  <CheckCircle className="w-3.5 h-3.5 text-green-500" />
                  <span>Sem robôs, pessoas reais</span>
                </div>
              </div>
            </div>

            <button
              onClick={openWhatsApp}
              className="w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white py-2.5 px-4 rounded-xl font-semibold text-sm shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2 hover:underline"
            >
              <MessageCircle className="w-4 h-4" />
              Iniciar Conversa
            </button>
          </div>
        )}

        {/* WhatsApp Button */}
        <div className="relative">
          {/* Gentle pulse ring */}
          <div className="absolute inset-0 rounded-full bg-green-500 gentle-pulse" 
               style={{ transform: 'scale(1.1)' }}></div>
          
          <button
            onClick={openWhatsApp}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className="relative bg-gradient-to-br from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white p-4 rounded-full shadow-2xl transition-all duration-500 hover:scale-110 group"
            aria-label="WhatsApp"
          >
            <MessageCircle className="w-7 h-7 relative z-10" />
            
            {/* Badge de notificação */}
            <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center shadow-lg subtle-bounce">
              1
            </div>

            {/* Hover tooltip */}
            {isHovered && !isExpanded && (
              <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap shadow-xl">
                Fale conosco
                <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 rotate-45 w-2 h-2 bg-gray-900"></div>
              </div>
            )}
          </button>
        </div>
      </div>
    </>
  );
};
